"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCanonical = exports.getOIDFromValueSet = exports.isVSACUrl = exports.VSAC_BASE = void 0;
const VSAC_REGEX = /http:\/\/cts\.nlm\.nih\.gov.*ValueSet/;
const OID_REGEX = /([0-9]+\.)+[0-9]+/;
// Base URL for current version can be found at https://www.nlm.nih.gov/vsac/support/usingvsac/vsacfhirapi.html
exports.VSAC_BASE = 'http://cts.nlm.nih.gov/fhir/ValueSet';
function isVSACUrl(url) {
    return VSAC_REGEX.test(url);
}
exports.isVSACUrl = isVSACUrl;
function getOIDFromValueSet(url) {
    const match = url.match(OID_REGEX);
    if (match !== null) {
        return match[0];
    }
    return null;
}
exports.getOIDFromValueSet = getOIDFromValueSet;
function normalizeCanonical(url) {
    const oid = getOIDFromValueSet(url);
    if (oid !== null) {
        return `${exports.VSAC_BASE}/${oid}`;
    }
    return null;
}
exports.normalizeCanonical = normalizeCanonical;
//# sourceMappingURL=VSACHelper.js.map